import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { endpoints } from '../api/endpoints';
import { homeShelfCuisines, type CuisineShelfMeta } from '../lib/cuisines';
import { TodaySection } from '../components/TodaySection';
import { MealPlanCard } from '../components/MealPlanCard';
import { CuisineShelf } from '../components/CuisineShelf';

function greeting(d = new Date()): string {
  const h = d.getHours();
  if (h < 6) return 'Доброй ночи';
  if (h < 12) return 'Доброе утро';
  if (h < 18) return 'Добрый день';
  return 'Добрый вечер';
}

export function HomeScreen() {
  const navigate = useNavigate();
  const [shelves, setShelves] = useState<CuisineShelfMeta[]>([]);

  useEffect(() => {
    let alive = true;
    endpoints.getCuisines().then(
      (list) => {
        if (alive) setShelves(homeShelfCuisines(list));
      },
      () => {
        // Сбой загрузки кухонь не критичен — лента работает без полок.
        if (alive) setShelves([]);
      },
    );
    return () => {
      alive = false;
    };
  }, []);

  return (
    <div className="space-y-7 px-4 pt-8">
      <div className="flex items-start justify-between gap-3">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.14em] text-primary-600/80">{greeting()}</p>
          <h1 className="mt-1.5 text-[26px] font-bold leading-tight text-ink">Готовим дома</h1>
        </div>
        <div className="mt-1 flex shrink-0 items-center gap-2">
          <button
            onClick={() => navigate('/billing')}
            aria-label="Тарифы и подписка"
            className="rounded-xl bg-primary-50 p-2 text-primary-700 ring-1 ring-inset ring-primary-100 transition active:scale-[0.98]"
          >
            <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
              <path d="M3 7l4 4 5-6 5 6 4-4v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V7z" strokeLinejoin="round" />
            </svg>
          </button>
          <button
            onClick={() => navigate('/import')}
            aria-label="Добавить рецепт по ссылке"
            className="rounded-xl bg-primary-50 px-3 py-2 text-sm font-semibold text-primary-700 ring-1 ring-inset ring-primary-100 transition active:scale-[0.98]"
          >
            + По ссылке
          </button>
        </div>
      </div>

      {/* Быстрые входы сразу под приветствием — видны без прокрутки (фидбэк Идриса).
          Компактные плитки 2-в-ряд: 4 входа без лишней прокрутки, высоты выравнивает сетка. */}
      <div className="grid grid-cols-2 gap-3">
        {([
          ['/from-product', 'Из продукта'],
          ['/festive', 'Праздничное'],
          ['/calories', 'Калории'],
          ['/by-time', 'Быстрые'],
        ] as const).map(([to, label]) => (
          <button
            key={to}
            onClick={() => navigate(to)}
            className="flex items-center justify-between rounded-2xl bg-white px-4 py-3.5 text-left shadow-card transition active:scale-[0.99]"
          >
            <span className="font-semibold text-ink">{label}</span>
            <span className="text-primary-600">→</span>
          </button>
        ))}
      </div>

      <TodaySection />
      <MealPlanCard />

      {shelves.map((c) => (
        <CuisineShelf key={c.key} cuisineKey={c.key} label={c.label} />
      ))}
    </div>
  );
}
